import { Component } from '@angular/core';
import { ContextChange, WidgetStyle } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';

@Component({
  selector: 'app-export-visitor-log-widget',
  templateUrl: './export-visitor-log-widget.component.html'
})
export class ExportVisitorLogWidgetComponent extends AbstractWidgetComponent {

  constructor(
    private appServerAPI: AppServerAPI
  ) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
